import { setPagestate } from "./AutoSavePageStateFun";
import { getPagestate } from "./AutoSavePageStateFun";
const autoSavePageState = {
  updated: function (el, binding) {
    if (binding.value) {
      if (binding.value != binding.oldValue) {
        setPagestate(binding.arg, binding.value);
      }
    }
  },
  install: function (Vue) {
    getPagestate();
    Vue.directive("tc-auto-save", autoSavePageState);
  }
};
export default autoSavePageState;